import React from 'react';
import { ListItem, ListItemAvatar, Avatar, ListItemText } from '@material-ui/core';
import { Error } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import AuditDescription from './AuditDescription';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  red: {
    backgroundColor: 'red'
  }
}));

const ErrorItem = ({ notif, markAsRead, data }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const documentName = data.document.name;
  const documentId = data.document.id;

  return (
    <ListItem
      alignItems='flex-start'
      onClick={markAsRead.bind(null, notif.id)}
      key={notif.id}
      divider
      className={classes.listItem}
    >
      <ListItemAvatar>
        <Avatar className={classes.red}>
          <Error />
        </Avatar>
      </ListItemAvatar>

      <ListItemText
        primary={documentName}
        secondary={
          <React.Fragment>
            <AuditDescription
              data={data}
            />
            <br />
            <Link
              to={`/document/detail/${documentId}`}
              target='_blank'
              style={{
                color: 'rgba(0, 174, 183, 0.87)',
                fontSize: 16,
                fontFamily: 'Roboto-Regular',
                fontWeight: 600,
                letterSpacing: '0.5px'
              }}
            >
              {t('notification:view')}
            </Link>
            <br />
            <Moment
              format='DD/MM/YYYY HH:mm:ss'
              style={{ fontSize: '0.8em' }}
            >
              {notif.createdAt}
            </Moment>
          </React.Fragment>
        }
      />

    </ListItem>
  );
};

ErrorItem.propTypes = {
  data: PropTypes.object,
  notif: PropTypes.object,
  markAsRead: PropTypes.func
};

export default ErrorItem;
